import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FaCheck } from "react-icons/fa";


interface ProgressBarProps {
  active: number;
  stepDone: any;
  options: any;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ active, stepDone, options }) => {
  const [currentActive, setCurrentActive] = useState<number>(1);
  const [stepsDone, setStepsDone] = useState<any>([]);
  const [steps, setSteps] = useState([]);
  const [totalWidth , setTotalWidth] = useState(0)

  useEffect(() => {
    if (active || stepsDone) {
      setCurrentActive(active);
      setStepsDone(stepDone);
      setSteps(options);
      if(stepDone[stepDone.length - 1] == options.length){
        setTotalWidth(100)
      }else{
        const length = (stepDone[stepDone.length - 1] - 1) * (100 / options.length)
        setTotalWidth(length)
      }
     
    }
  }, [active, stepDone, options]);


  return (
    <Root>
      <div className="progress_container">
        <div className="progress_barr" style={{width: `${totalWidth}%`}}></div>
      </div>
    </Root>
  );
};

const Root = styled.section`
  .progress_container {
    position: relative;
    margin-bottom: 10px;
    max-width: 100%;
    /* border: 1px solid #878787; */
    background-color:#fff;
    border-radius: 20px;
  }
  .progress_barr {
    background: #307FE2;
    transition: all 1s;
    display: block;
    height: 8px;
    border-radius: 10px;
}
 
  
`;


export default ProgressBar;
